import { render, staticRenderFns } from "./bPhoneInputValidation.vue?vue&type=template&id=41073be4"
import script from "./bPhoneInputValidation.ts?vue&type=script&lang=ts&external"
export * from "./bPhoneInputValidation.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports